import React, { Component } from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import {
  Card,
  Tooltip,
  notification,
  Form
} from 'antd'
import Request from '../../../../request'
import { connect } from 'react-redux'
import { TableComp } from 'sz-react-utils-lite'
import ReactHtmlParser from 'react-html-parser'
import { ChooseEmailModal, chooseEmailModalFxn, DisplayDate } from '../../../../components/_utils/appUtils'
import { getAllAbstracts } from '../actions'
import  AbstractFilters from '../../views/../views/abstractPages/AbstractFilters'
import { SendTemplateEmail } from '../../../email/actions'
// import DOIDrawer from '../drawers/DOIDrawer'

@Form.create()
class DeletedAbstracts extends Component {
  state = {
    edit: false,
    journalList: [],
    volumeList: [],
    issueList: [],
    isPublished: null,
    slugJournal: null,
    slugVolume: null,
    slugIssue: null,
    abstractId: null,
    filters: {},
    visibleDrawer: false,
    abstract: {},
    total: ''
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }

  apiRequest = (params) => {
    return new Promise(async (resolve) => {
      let { dispatch } = this.props
      let obj = {
        ...params,
        ...this.state.filters,
        status: 'Deleted'
      }
      let regExpFilters = []

      let data = await dispatch(getAllAbstracts({ ...obj, regExFilters: regExpFilters }))
      this.setState({ total: data.total })
      resolve(data)
    })
  }

  reload = () => {
    this.table.current.reload()
  }

  reloadTable = (data) => {
    if (data.fromDate && data.toDate) {
      data['submittedDate'] = {
        $gte: data.fromDate,
        $lte: data.toDate
      }
      delete data['fromDate']
      delete data['toDate']
    }
    this.setState({ filters: data }, () => {
      this.reload()
    })
  }

  deleteAbstract = async (data) => {
    let resp = await Request.deleteAbstract(data) // Updated to deleteAbstract API call
    this.reload()
  }

  sendMailFxn = (record) => {
    let { dispatch } = this.props
    chooseEmailModalFxn({
      callback: async (email) => {
        let obj = {
          abstractId: record._id, // Updated to abstractId
          fromEmail: email,
          emailType: 'acknowledgement',
          template: record.processingCharges > 0 ? 'abstractAcknowledgementWithCharges' : 'abstractAcknowledgementWithoutCharges',
          type: 'abstract' // Updated to abstract type
        }
        let resp = await dispatch(SendTemplateEmail({
          email,
          id: record._id,
          obj,
          template: obj.template
        }))
        if (resp && resp.success) {
          notification.success({
            message: resp.message
          })
          this.reload()
        }
      }
    })
  }

  render() {
    const { dispatch, form: { getFieldDecorator, getFieldValue, setFieldsValue }, loading } = this.props
    const { journalList, volumeList, issueList } = this.state

    const formProps = {
      getFieldDecorator, getFieldValue, loading
    }

    const columns = [
      {
        key: 'actions',
        title: 'Abstract Id',
        render: (val, record) => (
          <Tooltip title='Edit Details'>
            <a href={`/abstractView/${record._id}`}>
              {record.abstractNo || record.onlineAbstractId || record._id}
            </a>
          </Tooltip>
        )
      },
      {
        title: 'Submitted Date',
        key: 'submittedDate',
        dataIndex: 'submittedDate',
        width: 100,
        render: (item) => {
          return item ? DisplayDate(item) : null
        }
      },
      {
        title: 'Abstract Title',
        key: 'titleOfAbstract',
        dataIndex: 'titleOfAbstract', // Mapped to standard abstract title field
        render: (item, record) => {
          let title = item || record.title || record.manuScriptTitle
          return title ? ReactHtmlParser(title) : null
        }
      },
      {
        title: 'Country',
        key: 'country',
        dataIndex: 'country'
      },
      {
        title: 'Author',
        key: 'authorName',
        dataIndex: 'authorName',
        render: (item, record) => item || record.correspondingAuthor || 'N/A'
      },
      {
        title: 'Email',
        key: 'email',
        dataIndex: 'email',
        render: (item, record) => item || record.correspondingAuthorsEmail || 'N/A'
      },
      {
        title: 'Deleted Date',
        key: 'deletedDate',
        dataIndex: 'deletedDate',
        width: 100,
        render: (item) => {
          return item ? DisplayDate(item) : null
        }
      }
    ]

    return (
      <PageHeaderWrapper
        title={`Deleted Abstracts (${this.state.total})`}>
        <Card bordered={true}>
          <AbstractFilters callback={(data) => {
            this.reloadTable(data)
          }} />
          <TableComp ref={this.table} columns={columns} apiRequest={this.apiRequest} />
        </Card>
        {/*{this.state.visibleDrawer ? <DOIDrawer*/}
        {/*  visible={this.state.visibleDrawer}*/}
        {/*  abstractId={this.state.abstract._id}*/}
        {/*  abstract={this.state.abstract}*/}
        {/*  Id={this.state.abstract._id}*/}
        {/*  callback={this.reload}*/}
        {/*  edit={false}*/}
        {/*  onClose={() => this.setState({ visibleDrawer: false })}*/}
        {/*/> : null}*/}
      </PageHeaderWrapper>
    )
  }
}

const mapStateToProps = ({ global }) => ({
  categories: global.categories
})

const mapDispatchToProps = dispatch => ({
  dispatch
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeletedAbstracts)